import { render, staticRenderFns } from "./ownerRepairs.vue?vue&type=template&id=47820378&scoped=true"
import script from "./ownerRepairs.vue?vue&type=script&lang=js"
export * from "./ownerRepairs.vue?vue&type=script&lang=js"
import style0 from "./ownerRepairs.vue?vue&type=style&index=0&id=47820378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47820378",
  null
  
)

export default component.exports